function resolveRef(maybeRef) {
  if (maybeRef == null) {
    return maybeRef;
  }
  return "current" in maybeRef ? maybeRef.current : maybeRef;
}
export {
  resolveRef
};
//# sourceMappingURL=resolveRef.js.map
